import { FormInstance, Modal, UploadFile } from 'antd';
import Upload, { RcFile } from 'antd/es/upload';
import { UploadProps } from 'antd/es/upload/Upload';
import React, { useEffect, useState } from 'react';
import { imageHelper } from 'src/app/helpers';
import { getInterestsImages, InterestImage } from 'src/app/helpers/image.helper';
import { getImagesOfInterest } from 'src/app/services/image-service/image-service';
import { InterestsTypes } from 'src/enums/interests.enum';
import AddIcon from 'src/icons/AddIcon';

const DEFAULT_FILE_SIZE = 5;

interface IUploadInterestImageProps {
  fileSize?: number;
  form: FormInstance;
  recordId: string | undefined;
  interestType: InterestsTypes;
  setDeletedPictures: React.Dispatch<React.SetStateAction<string[]>>;
  defaultFileList?: UploadFile[];
}
// This component is used to create upload picture field that is limited to 5 for identified interest forms
const UploadInterestImage: React.FC<IUploadInterestImageProps> = ({
  fileSize,
  form,
  recordId,
  interestType,
  setDeletedPictures,
  defaultFileList,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [fileList, setFileList] = useState<UploadFile[]>(defaultFileList ?? []);
  const [imageList, setImageList] = useState<InterestImage[]>([]);

  // When file list is changed update form item named pictures
  useEffect(() => {
    form.setFieldValue('pictures', fileList);
  }, [fileList]);

  /*
  Get images of selected interest
  Convert them into base 64 with getInterestsImages function and set to image list
  */
  useEffect(() => {
    const getImages = async (id: string) => {
      const { data } = await getImagesOfInterest({
        id,
        interestType,
      });
      if (!data) return;
      const images = getInterestsImages(data);

      setImageList(images);
    };
    if (recordId) {
      getImages(recordId);
    }
  }, []);

  // Set file list with converted image list to display images on form
  useEffect(() => {
    if (imageList && imageList.length) {
      setFileList(
        imageList.map(({ filename, source }, idx) => ({
          uid: idx.toString(),
          name: filename,
          url: `data:image/png;base64,${source}`,
        })),
      );
    }
  }, [imageList]);

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await imageHelper.getBase64(file.originFileObj as RcFile);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
  };

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      <AddIcon />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  // const checkPicture = async (file: Blob, filename: string) => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("file", new File([file], filename));
  //     if(interestType === InterestsTypes.Person){
  //       const { data } = await axios.post(
  //         finalUrlsConfig().interest.identified.person.checkPicture,
  //         formData
  //         );
  //         return data;
  //     } else if(interestType === InterestsTypes.Location){
  //       const { data } = await axios.post(
  //         finalUrlsConfig().interest.identified.location.checkPicture,
  //         formData
  //       );
  //       return data;
  //     }
  //   } catch (error: any) {
  //     message.error(error.response.data.message);
  //   }

  //   return false;
  // };

  const handleChange: UploadProps['onChange'] = async ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  // const checkPictureAsync = (file: RcFile): Promise<boolean> =>
  //   new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.readAsArrayBuffer(file);

  //     reader.onload = async () => {
  //       const res = reader.result;
  //       if (!res) {
  //         reject();
  //       }

  //       const isPassed = await checkPicture(
  //         new Blob([res as ArrayBuffer]),
  //         file.name
  //       );
  //       resolve(isPassed);
  //     };
  //   });

  // const onRemoveImage = async (file: UploadFile) => {
  //   try {
  //     const result = await removeImage({ interestType, photoName: file.name });
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // };
  const onRemoveImage = (file: UploadFile) => {
    if (recordId) {
      setDeletedPictures((prev) => [...prev, file.name]);
    }
  };

  return (
    <>
      <Upload
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        onRemove={(file) => onRemoveImage(file)}
        multiple
        // beforeUpload={async (file) => {
        //   const result = await checkPictureAsync(file);
        //   if (!result) return Upload.LIST_IGNORE;
        //   return false;
        // }}
        beforeUpload={(_file, _fileList) => {
          return false;
        }}
        className="interest-upload"
      >
        {fileList.length >= (fileSize || DEFAULT_FILE_SIZE) ? null : uploadButton}
      </Upload>
      <Modal open={previewOpen} title={previewTitle} centered footer={null} onCancel={handleCancel}>
        <img alt="example" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </>
  );
};

export default UploadInterestImage;
